module.exports = __webpack_public_path__ + "fonts/Inter-BoldItalic.e0879d6.woff";